import { backendAPI } from '../../helper/apis';

export const savePolygon = (params) => backendAPI.post('/polygons', params);